import { useState, useCallback, useMemo } from "react";
import * as Styled from "./style";
import { BreadcrumbsListBlock } from "~/components/blocks/product/common/blocks/breadcrumbs-list-block";
import { ProductBanner } from "~/components/blocks/product/common/blocks/product-banner";
import { ProductDescription } from "~/components/blocks/product/common/blocks/product-description";
import { ProductHelpBanner } from "~/components/blocks/product/common/blocks/product-help-banner";
import { BannerItem } from "~/components/blocks/product/common/blocks/product-related-items/collection-banner-item";
import { CollectionItem } from "~/components/blocks/product/common/blocks/product-related-items/collection-item";
import { RecommendItem } from "~/components/blocks/product/common/blocks/product-related-items/recommend-item";
import { ProductTitle } from "~/components/blocks/product/common/blocks/product-title";
import { SampleViewerModal } from "~/components/blocks/product/common/video-legacy-season/sample-viewer-modal";
import { VideoLegacyCarousel } from "~/components/blocks/product/common/video-legacy-season/video-legacy-carousel";
import { VideoLegacySeasonTab } from "~/components/blocks/product/common/video-legacy-season/video-legacy-season-tab";
import type { VideoLegacySeasonType } from "~/components/blocks/product/type-guard";
import { useRatingBlock } from "~/hooks/use-rating-block";

type VideoLegacySeasonProps = { videoLegacySeasonData: VideoLegacySeasonType };

export const VideoLegacySeason = (props: VideoLegacySeasonProps) => {
  const { videoLegacySeasonData } = props;

  const [selectedSampleImageIndex, setSelectedSampleImageIndex] = useState(0);

  const onSelectedImageIndex = useCallback((index: number) => {
    setSelectedSampleImageIndex(index);
  }, []);

  const gravureSeasonImageData =
    useMemo(() => {
      const packageSampleImage = [
        {
          image: videoLegacySeasonData.packageImage,
          imageLarge: videoLegacySeasonData.packageLargeImage || "",
        },
      ];
      const hasPackageLargeImage =
        videoLegacySeasonData.packageLargeImage !== "" &&
        videoLegacySeasonData.packageLargeImage !== undefined &&
        videoLegacySeasonData.packageLargeImage !== null;
      const gravureSampleImages = hasPackageLargeImage
        ? packageSampleImage.concat(videoLegacySeasonData.samplePictures)
        : videoLegacySeasonData.samplePictures;

      return gravureSampleImages;
    }, [videoLegacySeasonData.packageLargeImage, videoLegacySeasonData.packageImage]) ?? [];

  const { isRestrictedContentByUserStatus } = useRatingBlock();
  const ratingCategory = videoLegacySeasonData.rating.category;

  return (
    <>
      <ProductBanner videoData={videoLegacySeasonData} />

      <Styled.DivProductTitlePadding>
        <ProductTitle videoData={videoLegacySeasonData} />
        <ProductHelpBanner videoData={videoLegacySeasonData} />
        <ProductDescription videoData={videoLegacySeasonData} />
      </Styled.DivProductTitlePadding>

      {!isRestrictedContentByUserStatus(ratingCategory, true) && (
        <VideoLegacyCarousel
          gravureSeasonImageData={gravureSeasonImageData}
          onSelectedImageIndex={onSelectedImageIndex}
        />
      )}

      <Styled.DivVideoLegacyTabPadding>
        <VideoLegacySeasonTab
          videoLegacySeasonData={videoLegacySeasonData}
          isAdultBlock={!isRestrictedContentByUserStatus(ratingCategory, true)}
        />
      </Styled.DivVideoLegacyTabPadding>

      <Styled.DivProductItemsFlexContainer>
        {!isRestrictedContentByUserStatus(ratingCategory, true) && (
          <RecommendItem
            categories={videoLegacySeasonData.categories}
            contentType={videoLegacySeasonData.content.contentType}
          />
        )}
        <BannerItem bannerType="scratch" videoData={videoLegacySeasonData} />
        <BannerItem bannerType="onlineCrane" videoData={videoLegacySeasonData} />
        {!isRestrictedContentByUserStatus(ratingCategory, true) && (
          <>
            <CollectionItem collectionType="videos" videoData={videoLegacySeasonData} />
            <CollectionItem collectionType="books" videoData={videoLegacySeasonData} />
          </>
        )}
        <BannerItem bannerType="mono" videoData={videoLegacySeasonData} />
      </Styled.DivProductItemsFlexContainer>

      <BreadcrumbsListBlock videoData={videoLegacySeasonData} />

      <SampleViewerModal
        selectedSampleImageIndex={selectedSampleImageIndex}
        gravureSeasonImageData={gravureSeasonImageData}
      />
    </>
  );
};
